import React from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import StaffCertificates from "./StaffCertificates";
import { ExportExcelPO, ExportPO, getPOSearch, ExportMDAndSDoc } from "../Actions/ShipViewAPI";
import swal from "sweetalert";


let Equipments = ['A_Equipment1', 'B_Equipment2', 'C_Equipment'];

class POHazardessMaterial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SelectedFromDate: "",
            SelectedToDate: "",
            fromDate: "",
            toDate: "",
            totalEquipments: 100,
            totalExpiredEquipments: 99,
            totalExpiringEquipments: 100,
            fromDatePickerIsOpen: false,
            toDatePickerIsOpen: false,
            IHMPresenseYes: true,
            IHMPresenseNo: false,
            searchData: {
                ShipId: 0,
                PODateFrom: "",
                PODateTo: "",
                PONumber: "",
                IHMPresense: true,
                underReview: false,
                pageSize: 100,
                pagenumber: 1
            },
            EquipmentList: ['A_Equipment1', 'B_Equipment2', 'C_Equipment'],
            EquipmentName: '',
            serviceType: [],
            isChecked: false,
            isActive: false
        };
        this.handleFromDateChange = this.handleFromDateChange.bind(this);
        this.handleToDateChange = this.handleToDateChange.bind(this);
        this.openFromDatePicker = this.openFromDatePicker.bind(this);
        this.openToDatePicker = this.openToDatePicker.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.SearchEquipmentData = this.SearchEquipmentData.bind(this);
        this.ClearSearchField = this.ClearSearchField.bind(this);
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        const { dispatch, match, MaterialValidationSearch } = this.props;
        let shipId = JSON.parse(localStorage.getItem("shipId"));
        if (MaterialValidationSearch) {
            this.state.searchData = MaterialValidationSearch;
            if (MaterialValidationSearch.IHMPresense == false && MaterialValidationSearch.underReview == false) {
                this.state.IHMPresenseNo = true;
                this.state.IHMPresenseYes = false;
                this.state.searchData.underReview = false;
            }
            else if (MaterialValidationSearch.IHMPresense == true && MaterialValidationSearch.underReview == false) {
                this.state.IHMPresenseNo = false;
                this.state.IHMPresenseYes = true;
                this.state.searchData.underReview = false;
            }
            else {
                this.state.IHMPresenseNo = false;
                this.state.IHMPresenseYes = false;
                this.state.searchData.underReview = true;
            }
        }
        this.setState({});
        if (match.params.id) {
            this.state.searchData.ShipId = match.params.id;
        }
        else {
            this.state.searchData.ShipId = shipId;
        }

        this.SearchEquipmentData(1);
        console.log(MaterialValidationSearch, "test material validation");
        // if (match.params.id) {
        //     // dispatch(getShipsCount(match.params.id));
        //     // dispatch(getShipDeatil(match.params.id));
        // }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch } = nextProps;
        if (nextProps.isMDSearch) {
            prevState.searchDate = nextProps.MDSearchData;
        }

        if (nextProps.MDDeleteSuccess) {
            prevState.searchDate = nextProps.MDSearchData;
            // dispatch(getShipEquipmentSearchlist(prevState.searchDate));
        }
    }

    SearchEquipmentData(pgno) {
        this.state.searchData["pagenumber"] = pgno;
        const { dispatch } = this.props;
        dispatch({
            type: "MaterialValidationSearch",
            data: this.state.searchData
        });
        dispatch(getPOSearch(this.state.searchData));
    }

    ClearSearchField() {
        const { dispatch, match } = this.props;
        let shipId = JSON.parse(localStorage.getItem("shipId"));
        let SearchItem = {
            ShipId: 0,
            PODateFrom: "",
            PODateTo: "",
            PONumber: "",
            IHMPresense: true,
            underReview: false,
            pageSize: 100,
            pagenumber: 1
        };
        if (match.params.id) {
            SearchItem.ShipId = match.params.id;
        }
        else {
            SearchItem.ShipId = shipId;
        }
        this.setState({
            IHMPresenseNo: false, IHMPresenseYes: true, searchData: SearchItem
        });
        dispatch({
            type: "MaterialValidationSearch",
            data: SearchItem
        });
        dispatch(getPOSearch(SearchItem));
    }

    handleFromDateChange(date) {
        this.state.searchData.PODateFrom = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            SelectedFromDate: date,
            fromDatePickerIsOpen: false,
        });
    }

    handleToDateChange(date) {
        if (Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >= this.state.searchData.PODateFrom) {
            this.state.searchData.PODateTo = Moment(new Date(Date.parse(date))).format(
                "YYYY-MM-DD"
            );
        } else {
            swal('Error!', 'To date must be greater than from date ', 'warning');
        }
        this.setState({
            SelectedToDate: date,
            toDatePickerIsOpen: false,
        });
    }

    openFromDatePicker() {
        this.setState({
            toDatePickerIsOpen: false,
            fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
        });
    }

    openToDatePicker() {
        this.setState({
            fromDatePickerIsOpen: false,
            toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
        });
    }

    handleBlur() {
        this.setState({
            toDatePickerIsOpen: false,
            fromDatePickerIsOpen: false,
        });
    }

    handleInputChange(e, field) {

        this.state.searchData[field] = e.target.value;
        this.setState({
            searchData: this.state.searchData,
        });
    }

    handleRadioButtonChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "IHMPresenseYes") {
            this.setState({ IHMPresenseYes: true, IHMPresenseNo: false });
            this.state.searchData['IHMPresense'] = true;
            this.state.searchData['underReview'] = false;
        } else if (nodeName === "IHMPresenseNo") {
            this.setState({ IHMPresenseYes: false, IHMPresenseNo: true });
            this.state.searchData['IHMPresense'] = false;
            this.state.searchData['underReview'] = false;
        }
        else if (nodeName === "underReview") {
            this.setState({ IHMPresenseYes: false, IHMPresenseNo: false });
            this.state.searchData['IHMPresense'] = false;
            this.state.searchData['underReview'] = true;
        }
    }

    suggestMItable(event) {
        let results = this.state.EquipmentList.filter((table) => {
            return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
        });

        this.setState({ EquipmentList: results });
    }

    toggleVisibility = () =>
        this.setState(prevState => ({ isActive: !this.state.isActive }));

    render() {
        const { shipSearchResult, shipDetail, POSearchDetails } = this.props;
        return (
            <div className="full-height pb-4">
                <div className="row my-3">
                    <div className="col-lg-12">
                        <div className="panel-box">
                            <div className="card MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body">
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Hazardous Material Validation Log</h5>
                                </div>
                            </div>
                            <div className="search-filter-box">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <label className="form-label">PO Date From</label>
                                        <div
                                            className="input-group add-on date datepicker"
                                            data-date-format="yyyy-mm-dd"  >
                                            <input
                                                type="text"
                                                value={this.state.searchData.PODateFrom}
                                                className="form-control date-picker"
                                                placeholder=""
                                                name="POFromDate" ></input>
                                            <DatePicker
                                                selected={this.state.SelectedFromDate}
                                                onChange={this.handleFromDateChange}
                                                open={this.state.fromDatePickerIsOpen}
                                                onClickOutside={this.handleBlur}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                popperPlacement="top-end"
                                                className="form-control date-picker w-5 hide-date" />
                                            <div
                                                className="input-group-btn calendar-icon"
                                                onClick={this.openFromDatePicker} >
                                                <button className="btn btn-default">
                                                    <i className="fa fa-calendar mt-1"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <label className="form-label">PO Date To</label>
                                        <div
                                            className="input-group add-on date datepicker"
                                            data-date-format="yyyy-mm-dd" >
                                            <input
                                                value={this.state.searchData.PODateTo}
                                                type="text"
                                                placeholder=""
                                                className="form-control date-picker"
                                                name="POToDate"
                                                data-date-format="yyyy-mm-dd"
                                            />
                                            <DatePicker
                                                selected={this.state.SelectedToDate}
                                                onChange={this.handleToDateChange}
                                                open={this.state.toDatePickerIsOpen}
                                                onClickOutside={this.handleBlur}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                popperPlacement="top-end"
                                                className="form-control date-picker w-5 hide-date"
                                            />
                                            <div className="input-group-btn calendar-icon">
                                                <button
                                                    className="btn btn-default"
                                                    onClick={this.openToDatePicker}>
                                                    <i className="fa fa-calendar mt-1"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <label className="form-label">PO Number</label><br></br>
                                        <input type="text" className="form-control" name="PONumber" value={this.state.searchData.PONumber} onChange={(e) => this.handleInputChange(e, "PONumber")}></input>
                                    </div>
                                    <div className="col-lg-3">
                                        <label className="form-label">IHM Presense</label><br></br>
                                        <div className="row ">
                                            <div className="col-sm-12 col-md-12 d-flex align-items-center mt-2" >
                                                <span className="mr-4">
                                                    <input type="radio" name="IHMPresenseYes" checked={this.state.IHMPresenseYes} onChange={(e) => this.handleRadioButtonChange(e)}></input>
                                                    <span className="ml-1">Yes</span>
                                                </span>
                                                <span className="mr-4">
                                                    <input type="radio" name="IHMPresenseNo" checked={this.state.IHMPresenseNo} onChange={(e) => this.handleRadioButtonChange(e)}></input>
                                                    <span className="ml-1">No</span>
                                                </span>
                                                <span className="mr-4">
                                                    <input type="radio" name="underReview" checked={this.state.searchData.underReview} onChange={(e) => this.handleRadioButtonChange(e)}></input>
                                                    <span className="ml-1">Under Review</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-12 col-sm-12 col-m-auto mt-4">
                                        <div className="form-group search-btn-col" style={{ textAlign: "end" }} >
                                            <button
                                                className="btn btn-info text-uppercase txtside-btn txtht-btn blue m-1"
                                                type="button" onClick={() => this.downloadMdSdoc()}>
                                                Download All MD And SDoC{" "}
                                            </button>
                                            <button
                                                className="btn btn-info text-uppercase txtside-btn txtht-btn blue m-1"
                                                type="button" onClick={() => this.downloadExcel()}>
                                                Export Excel{" "}
                                            </button>
                                            <button
                                                className="btn btn-info text-uppercase txtside-btn txtht-btn blue m-1"
                                                type="button" onClick={() => this.downloadPDF()}>
                                                Export PDF{" "}
                                            </button>
                                            <button
                                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-1"
                                                type="submit"
                                                onClick={() => this.SearchEquipmentData(1)}>
                                                Search{" "}
                                            </button>
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn m-1"
                                                type="button"
                                                onClick={() => this.ClearSearchField()}>
                                                Clear{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="py-2">
                  <div className="row">
                    <div className="col-sm-12">
                      {this.props.shipSearchResult ? (
                        <StaffCertificates
                          arraylist={shipSearchResult}
                          pageSize={this.state.searchDate.pagesize}
                          setUpdatedState={(value) => this.SearchEquipmentData(value)}
                          equipmentInfo={equipmentInfo}
                        />
                      ) : null}
                    </div>
                  </div>
                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                {POSearchDetails ? (
                    <StaffCertificates
                        arraylist={POSearchDetails}
                        pageSize={POSearchDetails.pagination.pageSize}
                        currentPage={POSearchDetails.pagination.currentPage}
                        totalRecords={POSearchDetails.pagination.totalcount ? POSearchDetails.pagination.totalcount : 0}
                        setUpdatedState={(value) => this.SearchEquipmentData(value)}
                    />
                ) : null}
            </div>
        );
    }

    downloadPDF() {
        const { dispatch } = this.props;
        dispatch(ExportPO(this.state.searchData));
    }

    downloadExcel() {
        const { dispatch } = this.props;
        dispatch(ExportExcelPO(this.state.searchData));
    }

    downloadMdSdoc() {
        const { dispatch, match } = this.props;
        let shipId = JSON.parse(localStorage.getItem("shipId"));
        if (match.params.id) {
            dispatch(ExportMDAndSDoc(match.params.id));
        }
        else {
            dispatch(ExportMDAndSDoc(shipId));
        }
    }
}



function mapStateToProps(state) {

    return {
        //BY BALU MOORTHI
        POSearchDetails: state.ShipViewReducer.POSearchDetails,
        MaterialValidationSearch: state.ShipViewReducer.MaterialValidationSearch,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(POHazardessMaterial);
